import type { FaireProductEntity } from "../../entity_types/product";

export const p_qqrtsaxd8c: FaireProductEntity = {
  token: "p_qqrtsaxd8c",
  type: "product",
  name: "Tan Bandana Fringe Cardigan",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/d36155d300554b646ea9653e5b4905d479ea6d41b39bb3e8a12162d7be4c8032.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4745b95c9af8a6c24e889c39d643358e60660b224626691f9bc217053d1444ae.jpeg",
    "https://cdn.faire.com/fastly/18f095a759e6c5a7b57afc80b58717997906f10da592939b6b9d05d096d07723.jpeg",
    "https://cdn.faire.com/fastly/5e716db3b56d987950594afe875eb284245a1e3cdfb55858692e1e89d76d48d8.jpeg",
    "https://cdn.faire.com/fastly/a657b8c46333f8d686de128252cd419de7c324eb646779f17a3ea836f500516e.jpeg"
  ],
  priceDollars: 33.95,
  description: "Tan Bandana Fringe Cardigan featuring an allover black bandana-inspired pattern, designed with an open front, self-tie waist closure, two front pockets, long sleeves, and fringe trim along the hem. Finished in a soft knit fabric with a relaxed fit for easy western-inspired layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:55.769Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
